/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-07-03 19:42:41
 * Description :
 * -----
 * Last Modified: 2024-08-08 15:21:23
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */


import {lazy} from 'react';
import { RouterConfig } from '../../types';

const customerAndDeviceRouterConfig: RouterConfig[] = [
    {
        key: 'Customer&Device',
        title: 'menuTitleCustomerAndDevice',
        icon: 'CustomMenuSVG',
        subs: [
            {
                key: 'DCU Mgnt',
                title: 'menuTitleDcuManagement',
                route: '/home/customerAndDevice/dcuManagement',
                component: lazy(() => import('src/pages/customerAndDevice/dcuManagement')),
            },
            {
                key: 'Meter Mgnt',
                title: 'menuTitleMeterManagement',
                route: '/home/customerAndDevice/meterManagement',
                component: lazy(() => import('src/pages/customerAndDevice/meterManagement')),
            },
            {
                key: 'Customer Mgnt',
                title: 'menuTitleCustomerManagement',
                route: '/home/customerAndDevice/customerManagement',
                component: lazy(() => import('src/pages/customerAndDevice/customerManagement')),
            },

            {
                key: 'MeasurePoint Mgnt',
                title: 'menuTitleMeasurePointManagement',
                route: '/home/customerAndDevice/measurePointManagement',
                component: lazy(() => import('src/pages/customerAndDevice/measurePointMgnt')),
            },
        ],
    },
];

export default customerAndDeviceRouterConfig;
